// extracted by mini-css-extract-plugin
module.exports = {"footer":"s_footer__8tGud","nav":"s_nav__3e8hg","item":"s_item__mXC7B","contact":"s_contact__2yQGf"};